import React from 'react'

const Status = () => {
  return (
    <div>Commit Is Healthy</div>
  )
}

export default Status
